import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import Dashboard from '../dashboard/dashboard';

export default props => (
	<div id='id-content-wrapper' 
		className='content-wrapper' 
		style={{
			height: '100vh'
		}}>
		<Switch>
			<Route exact path='/' component={Dashboard} />
			<Redirect from='*' to='/' />
		</Switch>
	</div>
);
